import { render, staticRenderFns } from "./GoArtOpenInApp.vue?vue&type=template&id=395c307a&scoped=true"
import script from "./GoArtOpenInApp.vue?vue&type=script&lang=js"
export * from "./GoArtOpenInApp.vue?vue&type=script&lang=js"
import style0 from "./GoArtOpenInApp.vue?vue&type=style&index=0&id=395c307a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395c307a",
  null
  
)

export default component.exports